module.exports = __webpack_public_path__ + "static/img/quesheng.3417cff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quesheng.png
// module id = Y/F9
// module chunks = 1